<div
  class="standard-dropdown-item w-full flex justify-content-between gap-3"
  [class.align-items-start]="!singleLine"
  [class.align-items-center]="singleLine"
  [class.standard-dropdown-item--single-line]="singleLine">
  <div
    class="standard-dropdown-item__body flex-1 min-w-0"
    [class.flex]="singleLine"
    [class.align-items-center]="singleLine"
    [class.gap-2]="singleLine">
    <p
      class="standard-dropdown-item__name"
      [innerHTML]="item.name | highlightMatch: filterValue | safeHtml"></p>
    @if (item.extra?.length) {
      @if (singleLine) {
        <span class="standard-dropdown-item__extras">
          @for (extra of item.extra; track $index) {
            @if (extra?.content) {
              <span
                [class.frm-color-green]="extra?.color === 'emphasis'"
                [class.text-gray-500]="extra?.color === 'muted'"
                [class.text-red-500]="extra?.color === 'warning'"
                [class.font-bold]="extra?.font === 'bold'"
                [class.font-light]="extra?.font === 'thin'"
                [innerHTML]="extra?.content | highlightMatch: filterValue | safeHtml"></span>
            }
          }
        </span>
      } @else {
        @for (extra of item.extra; track $index) {
          <p
            class="mt-1"
            [class.frm-color-green]="extra?.color === 'emphasis'"
            [class.text-gray-500]="extra?.color === 'muted'"
            [class.text-red-500]="extra?.color === 'warning'"
            [class.font-bold]="extra?.font === 'bold'"
            [class.font-light]="extra?.font === 'thin'">
            <span [innerHTML]="extra?.content | highlightMatch: filterValue | safeHtml"></span>
          </p>
        }
      }
    }
  </div>
  @if (item.status) {
    <div class="flex-shrink-0 white-space-nowrap">
      <crm-status-label
        [name]="item.status.name"
        [color]="item.status.color"></crm-status-label>
    </div>
  }
</div>
